export const SET_VALUE = 'set_value';


// WEBPACK FOOTER //
// ./demo/src/actions/types.js